<template>
  <div>
    <div class="card-header">
      <div class="row justify-content-between">
        <div class="col-12 col-lg-4">
          <SearchComponent v-model="filters.search" />
        </div>
        <div class="col-12 col-lg-4 my-3">
          <router-link
            :to="{ name: 'back.events.crear' }"
            class="btn btn-primary float-right"
            v-if="permisos['eventos.crear']"
          >
            CREAR EVENTO
          </router-link>
        </div>
      </div>
    </div>
    <!-- /.card-header -->
    <div class="card-body" v-if="!loading">
      <template v-for="(event, index) in events.data">
        <div :key="index">
          <div class="row mb-2">
            <div class="col12 col-md-6">
              <div class="mb-2">
                  <strong>{{ event.codigo }}</strong> -
                  <span v-if="event.status==1" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                  <span v-if="event.status==0" class="mr-2"><i class="text-warning fas fa-pause-circle"></i></span>
                  <span v-if="event.tiene_recinto" class="mr-2"><i class="fas fa-map-marker-alt"></i></span>
                  - {{ event.nombre_completo }}</div>
            </div>
            <div class="col-12 col-md-6 text-right">
              <div>
                <button class="btn btn-secondary ml-2" v-on:click.prevent="showModalCambiarImagen(event)"> Cambiar imagen</button>
                <router-link
                    :to="{ name: 'back.events.compania', params: { evento_id: event.id}}"
                    class="btn btn-primary ml-2"
                    v-if="permisos['eventos.editar']"
                >
                  <i class="fas fa-users"></i> Compañia
                </router-link>
                <router-link
                  :to="{ name: 'back.events.informe', params: { id: event.id } }"
                  class="btn btn-primary ml-2"
                  v-if="permisos['eventos.informe']"
                >
                  <i class="fas fa-chart-bar"></i> Informe
                </router-link>
                <button
                  type="button"
                  name="button"
                  class="btn btn-primary ml-2"
                  @click="expandir(index)"
                >
                  <i class="far fa-calendar-alt"></i> Sesiones ({{ event.numero_sesiones }})
                </button>

                <OpcionesDropdownComponent
                  v-bind:options="[
                    {
                      to: {
                        name: 'back.events.editar',
                        params: { evento_id: event.id },
                      },
                      label: 'Editar',
                    },
                    {
                      to: {
                        name: 'back.events.puertas.index',
                        params: { evento_id: event.id },
                      },
                      label: 'Puertas',
                    },
                    ...(permisos['eventos.control_accesos']
                      ? [
                          {
                            to: {
                              name: 'back.events.control-acceso',
                              params: { evento_id: event.id },
                            },
                            label: 'C. Acceso',
                          },
                        ]
                      : []),
                    {
                      type: 'action',
                      action: () => showModal('borrar-' + event.id),
                      label: 'Borrar',
                    },  
                  ]"
                  class="ml-2"
                />
              </div>
            </div>
          </div>
          <DeleteEventModal
            :evento="event"
            v-on:close="closeModal"
          ></DeleteEventModal>
        </div>
        <div
          :key="'2-' + index"
          v-show="expand.indexOf(index) >= 0"
        >
          <div class="row mb-5">
            <div class="col-12">
              <button
                class="float-right btn btn-primary"
                @click.prevent="showCrearSesion(event)"
              >
                Crear sesion
              </button>
            </div>
            <div class="col-12 mt-3">
              <div>
                <template v-for="(sesion, index) in event.sesiones">
                  <div :key="index" class="row">
                  <div class="col-12 col-md-2 mb-2"><span v-if="sesion.fecha_provisional==1" class="mr-2"><i class="text-danger fas fa-question-circle"></i></span> {{ sesion.fecha }}</div>
                    <div class="col-12 col-md-10 text-right">
                      <button
                        class="btn btn-secondary ml-2 mb-2"
                        @click="getUrlEvent(event, sesion)"
                      >
                        <i class="fas fa-copy"></i> Copiar url
                      </button>
                      <button
                        class="btn btn-secondary ml-2 mb-2"
                        @click="openTestTab(event, sesion)"
                      >
                        <i class="fas fa-vial"></i> Test venta
                      </button>
                      <router-link
                        :to="{
                          name: 'back.events.sesion.bloquear-asientos',
                          params: { evento_id: event.id, sesion_id: sesion.id },
                        }"
                        class="btn btn-secondary ml-2 mb-2"
                        v-if="permisos['eventos.vender']"
                      >
                        <i class="fas fa-lock"></i> Bloquear butacas
                      </router-link>
                      <router-link
                        :to="{
                          name: 'back.events.venta',
                          params: { evento_id: event.id, sesion_id: sesion.id },
                        }"
                        class="btn btn-secondary ml-2 mb-2"
                        v-if="permisos['eventos.vender']"
                      >
                        <i class="fas fa-euro-sign"></i> Venta
                      </router-link>
                      <router-link
                        :to="{
                          name: 'back.events.entradas',
                          params: { evento_id: event.id, sesion_id: sesion.id },
                        }"
                        class="btn btn-secondary ml-2 mb-2"
                      >
                        <i class="fas fa-ticket-alt"></i> Listado ventas
                      </router-link>
                      <router-link
                        :to="{
                          name: 'back.events.sesion.configuracion',
                          params: { evento_id: event.id, sesion_id: sesion.id },
                        }"
                        class="btn btn-secondary ml-2 mb-2"
                      >
                        <i class="fas fa-cogs"></i> Precios
                      </router-link>
                      <button
                        class="btn btn-secondary ml-2 mb-2"
                        v-on:click.prevent="
                          showModalEditarSesion(sesion, event)
                        "
                      >
                        <i class="fas fa-edit"></i> Editar
                      </button>
                      <button
                        class="btn btn-secondary ml-2 mb-2"
                        v-on:click.prevent="
                          showModalBorrarSesion(sesion, event)
                        "
                      >
                        <i class="fas fa-trash"></i> Borrar
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>

      <CrearSesionModal
        v-if="active_event"
        :evento="active_event"
        v-on:close="closeModal"
      ></CrearSesionModal>
      <EditarSesionModal
        v-if="active_sesion"
        :sesion="active_sesion"
        :evento="active_event"
        v-on:close="closeModal"
      ></EditarSesionModal>
      <DeleteSesionModal
        v-if="active_sesion"
        :sesion="active_sesion"
        :evento="active_event"
        v-on:close="closeModal"
      ></DeleteSesionModal>
      <CambiarImagen v-if="active_event" :evento="active_event"></CambiarImagen>
      <hr />
      <div class="row justify-content-between">
        <div class="col-12 col-lg-3">
          <ElementosPorPaginaComponent v-model="filters.per_page"></ElementosPorPaginaComponent>
        </div>
        <div class="col-12 col-lg-4" v-if="events">
          <PaginateComponent
            :current_page="events.meta.current_page"
            :last_page="events.meta.last_page"
            v-on:change_page="setPage"
          ></PaginateComponent>
        </div>
      </div>
    </div>
    <div class="card-body" v-else>
        <LoaderComponent></LoaderComponent>
    </div>
  </div>
</template>

<script>
import LoaderComponent from "@/components/preloader/LoaderComponent";
import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
import DeleteEventModal from "@/views/backend/events/modals/DeleteEventModal";
import DeleteSesionModal from "@/views/backend/events/modals/DeleteSesionModal";
import CrearSesionModal from "@/views/backend/events/modals/CrearSesionModal";
import EditarSesionModal from "@/views/backend/events/modals/EditarSesionModal";
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
import SearchComponent from "@/components/backend/components/SearchComponent";
import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
import CambiarImagen from "@/components/backend/eventos/CambiarImagen";

export default {
  data() {
    return {
      events: { data: [], meta: { current_page: 1 }},
      expand: [],
      loading: true,
      filters: {
        per_page: 10,
        page: 1,
        search: "",
        e: "actuales",
      },
      active_event: null,
      active_sesion: null,
      active_cambiar_imagen: null,
    };
  },
  created() {
    this.debouncedGetEvents = _.debounce(this.getEvents, 500);
    this.getEvents();
  },
  computed: {
    permisos() {
      return this.$store.getters.getPermisos;
    },
    footer() {
      return this.$store.getters.getFooter;
    },
  },
  mounted: function () {},
  watch: {
    "filters.search"() {
      this.debouncedGetEvents();
    },
  },
  methods: {
    async getUrlEvent(event, sesion) {
        var url = "";
        if(event.slug) {
            url = process.env.VUE_APP_CLE_FRONT + 'event/' + event.slug;
        } else {
            url = this.footer.url_gracias + 'eventos/' + event.id + '/' + sesion.id;
        }

        navigator.clipboard.writeText(url);
        this.$toast.success("Url copiada!");
    },
    openTestTab(event, sesion) {
      window.open(
        this.footer.url_gracias + 
        'eventos/' 
        + event.id 
        + '/' 
        + sesion.id 
        + '?venta_online=test');
    },
    showModalEditarSesion(sesion, evento) {
      this.active_sesion = sesion;
      this.active_event = evento;
      this.$nextTick(() => {
        this.$modal.show("editar-sesion-" + sesion.id);
      });
    },
    showModalBorrarSesion(sesion, evento) {
      this.active_sesion = sesion;
      this.active_event = evento;
      this.$nextTick(() => {
        this.$modal.show("borrar-sesion-" + sesion.id);
      });
    },
    showCrearSesion(event) {
      this.active_event = event;
      this.$nextTick(() => {
        this.$modal.show("crear-sesion");
      });
    },
    getEvents: function () {
      this.loading = true;
      const data = {
        filters: this.filters,
      };
      this.$store
        .dispatch(this.config.getVuexAlias("back.events.index"), data)
        .then(res => {
          this.events = res.data;
          console.log(res);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    expandir(index) {
      if (this.expand.indexOf(index) >= 0) {
        this.expand.splice(this.expand.indexOf(index), 1);
      } else {
        this.expand.push(index);
      }
    },
    setPage(page) {
      this.filters.page = page;
      this.getEvents();
    },
    showModal(modal) {
      this.expand = [];
      this.$modal.show(modal);
    },
    closeModal(modal, borrado) {
      this.active_sesion = null;
      this.active_event = null;
      this.$modal.hide(modal);
      if (borrado) {
        this.getEvents();
      }
    },
    showModalCambiarImagen (evento) {
      this.active_event = evento;
      console.log(this.active_sesion)
      this.$nextTick(() => {
        this.$modal.show('cambiar-imagen-' + evento.id);
      });
    }
  },
  components: {
    SearchComponent,
    LoaderComponent,
    PaginateComponent,
    DeleteEventModal,
    CrearSesionModal,
    EditarSesionModal,
    DeleteSesionModal,
    OpcionesDropdownComponent,
    ElementosPorPaginaComponent,
    CambiarImagen
  },
};
</script>
